export const FETCH_JOBS_SUCCESS = 'jobs/fetchAllSuccess';
export const FETCH_JOBS_ERROR = 'jobs/fetchAllError';

export const FETCH_JOB_SUCCESS = 'jobs/fetchOneSuccess';
export const FETCH_JOB_ERROR = 'jobs/fetchOneError';
